export default "__VITE_ASSET__cIBnmqEz__"